import { render, staticRenderFns } from "./NextOfKinDetails.vue?vue&type=template&id=081fb99e&scoped=true"
import script from "./NextOfKinDetails.vue?vue&type=script&lang=js"
export * from "./NextOfKinDetails.vue?vue&type=script&lang=js"
import style0 from "./NextOfKinDetails.vue?vue&type=style&index=0&id=081fb99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fb99e",
  null
  
)

export default component.exports